import styled from 'styled-components'  

import {
    Animation
} from 'ui/styled'
 



export const DashboardAnimation = styled(Animation).attrs({ 
    width: '100%',
    height: 420
})`             
`;
 